import { FC } from "react";
import { CurrentAndPriorTreatmentProps } from "../currentAndPriorTreatment/types";

const mainReasons = [
  "Gastroparesis",
  "Lipohypertrophy with malabsorption",
  "High risk of Hypoglycemia",
  "Needle Phobia and unable to self-inject",
];

const subReasons = [
  "Physical Impairment",
  "Visual Impairment",
  "Mental Impairment",
];

// 🔥 helper (important)
const cleanArray = (arr: string[] = []) => arr.filter(Boolean);

const AlternativeInsulinReasons: FC<CurrentAndPriorTreatmentProps> = ({
  watch,
  setValue,
}): JSX.Element => {

  const data =
    watch("prescription_information_attributes.reasons_alternative_insulins_not_effective") || {
      main: [],
      needle_phobia: [],
    };

  // ✅ CLEAN DATA (FIX)
  const mainSelected: string[] = cleanArray(data.main);
  const subSelected: string[] = cleanArray(data.needle_phobia);

  const needleLabel = "Needle Phobia and unable to self-inject";

  const isNeedleChecked = mainSelected.includes(needleLabel);

  // ✅ MAIN TOGGLE
  const toggleMain = (value: string, checked: boolean) => {
    let updatedMain = cleanArray(mainSelected);

    if (checked) {
      if (!updatedMain.includes(value)) {
        updatedMain.push(value);
      }
    } else {
      updatedMain = updatedMain.filter((v) => v !== value);
    }

    let updatedSub = subSelected;

    // 🔥 reset sub if needle unchecked
    if (value === needleLabel && !checked) {
      updatedSub = [];
    }

    setValue("prescription_information_attributes.reasons_alternative_insulins_not_effective", {
      main: updatedMain,
      needle_phobia: updatedSub,
    });
  };

  // ✅ SUB TOGGLE
  const toggleSub = (value: string, checked: boolean) => {
    let updatedSub = cleanArray(subSelected);

    if (checked) {
      if (!updatedSub.includes(value)) {
        updatedSub.push(value);
      }
    } else {
      updatedSub = updatedSub.filter((v) => v !== value);
    }

    setValue("prescription_information_attributes.reasons_alternative_insulins_not_effective", {
      main: mainSelected,
      needle_phobia: updatedSub,
    });
  };

  return (
    <div className="row mt-4">
      <h5>Reasons alternative Insulins are not Effective</h5>

      <div className="col-md-12">

        {/* ✅ MAIN CHECKBOXES */}
        {mainReasons.map((reason) => (
          <div className="form-check" key={reason}>
            <label className="form-check-label col-12">
              <input
                type="checkbox"
                className="form-check-input"
                checked={mainSelected.includes(reason)}
                onChange={(e) =>
                  toggleMain(reason, e.target.checked)
                }
              />
              {reason}
            </label>
          </div>
        ))}

        {/* ✅ SUB OPTIONS */}
        {isNeedleChecked && (
          <div className="ms-4 mt-2">
            {subReasons.map((sub) => (
              <div className="form-check" key={sub}>
                <label className="form-check-label col-12">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={subSelected.includes(sub)}
                    onChange={(e) =>
                      toggleSub(sub, e.target.checked)
                    }
                  />
                  {sub}
                </label>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
};

export default AlternativeInsulinReasons;